<template>
    <layout>
        <div class="login-area rn-section-gapTop">
            <div class="container">
                <div class="row g-5">
                    <div class="offset-3 col-lg-6 col-md-6 ml_md--0 ml_sm--0 col-sm-12">
                        <div class="form-wrapper-one">
                            <h4>Admin Login</h4>

                            <form @submit.prevent="handleLogin">
                                <div class="mb-5">
                                    <label for="email" class="form-label">Email address</label>
                                    <input
                                        id="email"
                                        type="email"
                                        class="form-control"
                                        v-model="email"
                                        required
                                    />
                                </div>

                                <div class="mb-5">
                                    <label for="password" class="form-label">Password</label>
                                    <input
                                        id="password"
                                        type="password"
                                        class="form-control"
                                        v-model="password"
                                        required
                                    />
                                </div>

                                <p v-if="errorMessage" class="text-danger mb-3">
                                    {{ errorMessage }}
                                </p>

                                <button
                                    type="submit"
                                    class="btn btn-primary mr--15"
                                    :disabled="loading"
                                >
                                    {{ loading ? 'Logging in...' : 'Log In' }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "@/firebase";

// admin.tortuga@gmail.com sentrys123

export default {
    name: "Login",
    components: { Layout },

    data() {
        return {
            email: "",
            password: "",
            loading: false,
            errorMessage: "",
        };
    },

    methods: {
        async handleLogin() {
            this.errorMessage = "";
            this.loading = true;

            try {
                await signInWithEmailAndPassword(auth, this.email, this.password);
                this.$router.push("/admin");
            } catch (error) {
                console.error("Login error:", error);

                switch (error.code) {
                    case "auth/invalid-email":
                        this.errorMessage = "Невалиден email адрес.";
                        break;
                    case "auth/user-not-found":
                    case "auth/wrong-password":
                    case "auth/invalid-credential":
                        this.errorMessage = "Грешен email или парола.";
                        break;
                    case "auth/too-many-requests":
                        this.errorMessage = "Твърде много опити. Опитай по-късно.";
                        break;
                    default:
                        this.errorMessage = "Възникна грешка при вход.";
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style scoped>
/* Центриране и фон */
.login-area {
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Card wrapper override */
.form-wrapper-one {
    background: rgba(20, 20, 30, 0.9) !important;
    padding: 30px !important;
    border-radius: 12px !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.4);
}

/* Заглавие */
.form-wrapper-one h4 {
    color: #fff !important;
    margin-bottom: 20px;
}

/* Labels */
.form-label {
    color: #ccc !important;
    font-size: 14px;
}

/* Inputs */
.form-control {
    background: #1e1e2f !important;
    border: 1px solid #333 !important;
    color: #fff !important;
    height: 45px;
    border-radius: 8px;
}

.form-control:focus {
    border-color: #4f46e5 !important;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.3) !important;
    background: #1e1e2f !important;
    color: #fff !important;
}

/* Button */
.btn-primary {
    background: linear-gradient(135deg, #4f46e5, #7c3aed) !important;
    border: none !important;
    height: 45px;
    border-radius: 8px;
    font-weight: 600;
}

.btn-primary:hover {
    opacity: 0.9;
}

/* Error */
.text-danger {
    color: #ff4d4f !important;
}

/* Малко spacing fix */
.mb-5 {
    margin-bottom: 20px !important;
}
</style>